(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const body = document.body;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lock = (locked) => body.classList.toggle('is-locked', locked);
  const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);

  window.addEventListener('load', () => {
    window.setTimeout(() => $('[data-loader]')?.classList.add('is-done'), 350);
  });

  const header = $('[data-header]');
  const progress = $('[data-scroll-progress]');
  let previousY = window.scrollY;
  let scrollTicking = false;
  const updateScroll = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    if (progress) progress.style.width = `${max > 0 ? (scrollY / max) * 100 : 0}%`;
    if (header) {
      const down = scrollY > previousY && scrollY > 150;
      header.classList.toggle('is-hidden', down);
    }
    previousY = scrollY;
    if (!reduceMotion) {
      $$('[data-parallax]').forEach((element) => {
        const rect = element.parentElement.getBoundingClientRect();
        element.style.translate = `0 ${Math.max(-28, Math.min(28, rect.top * -0.035))}px`;
      });
    }
    scrollTicking = false;
  };
  window.addEventListener('scroll', () => {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(updateScroll);
  }, { passive: true });
  updateScroll();

  if ('IntersectionObserver' in window && !reduceMotion) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }), { threshold: 0.12 });
    $$('[data-reveal], [data-image-reveal]').forEach((element, index) => {
      element.style.transitionDelay = `${(index % 3) * 70}ms`;
      observer.observe(element);
    });
  } else {
    $$('[data-reveal], [data-image-reveal]').forEach((element) => element.classList.add('is-visible'));
  }

  const openPanel = (panel) => { panel?.classList.add('is-open'); panel?.setAttribute('aria-hidden', 'false'); lock(true); };
  const closePanel = (panel) => { panel?.classList.remove('is-open'); panel?.setAttribute('aria-hidden', 'true'); lock(false); };
  const mobileMenu = $('[data-mobile-menu]');
  $('[data-menu-open]')?.addEventListener('click', () => openPanel(mobileMenu));
  $('[data-menu-close]')?.addEventListener('click', () => closePanel(mobileMenu));
  $$('.mobile-menu a').forEach((link) => link.addEventListener('click', () => closePanel(mobileMenu)));
  const searchPanel = $('[data-search-panel]');
  $('[data-search-open]')?.addEventListener('click', () => {
    openPanel(searchPanel);
    setTimeout(() => $('input', searchPanel)?.focus(), 300);
  });
  $('[data-search-close]')?.addEventListener('click', () => closePanel(searchPanel));

  const cartDrawer = $('[data-cart-drawer]');
  const openCart = () => openPanel(cartDrawer);
  const closeCart = () => closePanel(cartDrawer);
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));

  const toast = (message) => {
    const element = $('[data-toast]');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    setTimeout(() => element.classList.remove('is-visible'), 2200);
  };

  const renderCart = (cart) => {
    $$('[data-cart-count], [data-drawer-count]').forEach((node) => { node.textContent = cart.item_count; });
    const container = $('[data-cart-items]');
    if (!container) return;
    if (!cart.items.length) {
      container.innerHTML = '<div class="cart-empty"><p>Your bag is waiting for something warm.</p><a class="button button--dark" href="/collections/all">SHOP BESTSELLERS ↗</a></div>';
      return;
    }
    container.innerHTML = cart.items.map((item, index) => `<article class="cart-line"><img src="${item.image || ''}" alt="${item.product_title}"><div><p>NORUVA</p><h3><a href="${item.url}">${item.product_title}</a></h3><small>${item.variant_title || ''}</small><button data-cart-remove="${index + 1}">REMOVE</button></div><strong>${money(item.final_line_price)}</strong></article>`).join('');
    $$('[data-cart-remove]', container).forEach((button) => button.addEventListener('click', async () => {
      const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(button.dataset.cartRemove), quantity: 0 }) });
      renderCart(await response.json());
    }));
  };

  $$('form[action*="/cart/add"]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = $('button[type="submit"]', form);
    if (button) { button.disabled = true; button.dataset.originalText = button.textContent; button.textContent = 'ADDING…'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add item');
      const cartResponse = await fetch('/cart.js');
      renderCart(await cartResponse.json());
      openCart();
      toast('Added to your NORUVA bag');
    } catch (error) {
      toast(error.message);
    } finally {
      if (button) { button.disabled = false; button.textContent = button.dataset.originalText; }
    }
  }));

  $$('[data-demo-add]').forEach((button) => button.addEventListener('click', () => {
    const count = $('[data-cart-count]');
    if (count) count.textContent = String(Number(count.textContent || 0) + 1);
    toast(`${button.dataset.product} added to your bag`);
    openCart();
  }));

  $$('[data-quantity-minus], [data-quantity-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    if (!input) return;
    const next = Number(input.value || 1) + (button.hasAttribute('data-quantity-plus') ? 1 : -1);
    input.value = Math.max(1, next);
  }));

  $$('[data-mood]').forEach((link) => {
    const activate = () => {
      const index = link.dataset.mood;
      $$('[data-mood]').forEach((item) => item.classList.toggle('is-active', item === link));
      $$('[data-mood-image]').forEach((image) => image.classList.toggle('is-active', image.dataset.moodImage === index));
    };
    link.addEventListener('mouseenter', activate);
    link.addEventListener('focus', activate);
  });

  const reviewTrack = $('[data-review-track]');
  if (reviewTrack) {
    let reviewIndex = 0;
    const cards = $$('article', reviewTrack);
    const updateReviews = () => {
      const width = cards[0]?.getBoundingClientRect().width || 0;
      reviewTrack.style.transform = `translate3d(${-(width + 14) * reviewIndex}px,0,0)`;
      const meter = $('[data-review-progress]');
      if (meter) meter.style.width = `${((reviewIndex + 1) / cards.length) * 100}%`;
    };
    $('[data-review-next]')?.addEventListener('click', () => { reviewIndex = (reviewIndex + 1) % cards.length; updateReviews(); });
    $('[data-review-prev]')?.addEventListener('click', () => { reviewIndex = (reviewIndex - 1 + cards.length) % cards.length; updateReviews(); });
    window.addEventListener('resize', updateReviews);
    updateReviews();
  }

  $$('[data-tilt]').forEach((card) => {
    if (!matchMedia('(hover:hover) and (pointer:fine)').matches || reduceMotion) return;
    card.addEventListener('pointermove', (event) => {
      const rect = card.getBoundingClientRect();
      const rotateY = ((event.clientX - rect.left) / rect.width - 0.5) * 3;
      const rotateX = ((event.clientY - rect.top) / rect.height - 0.5) * -3;
      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });
    card.addEventListener('pointerleave', () => { card.style.transform = ''; });
  });

  $$('[data-product-zoom]').forEach((item) => item.addEventListener('click', () => item.classList.toggle('is-zoomed')));
  $$('[data-ugc-play]').forEach((button) => button.addEventListener('click', () => button.classList.toggle('is-playing')));
  $('[data-sticky-add]')?.addEventListener('click', () => $('.product-form button[type="submit"]')?.click());
  $('[data-scroll-top]')?.addEventListener('click', () => scrollTo({ top: 0, behavior: 'smooth' }));

  const popup = $('[data-newsletter-popup]');
  if (popup && !sessionStorage.getItem('noruva-popup-dismissed')) {
    setTimeout(() => { popup.classList.add('is-open'); popup.setAttribute('aria-hidden', 'false'); }, 6500);
  }
  $('[data-popup-close]')?.addEventListener('click', () => {
    popup?.classList.remove('is-open');
    popup?.setAttribute('aria-hidden', 'true');
    sessionStorage.setItem('noruva-popup-dismissed', 'true');
  });

  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closePanel(mobileMenu); closePanel(searchPanel); closeCart();
  });
})();
